import dynamic from "next/dynamic";

import "antd/dist/reset.css";
import "../layouts/app.less";

const App = dynamic(() => import("../components/App"), { ssr: false });

export default App;
